<template>
  <v-dialog
    v-model="opened"
    persistent
    max-width="600"
    @keydown.esc="$emit('update:opened', false)"
  >
    <v-card>
      <v-card-text class="text-xs-left">
        {{ message }}
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          class="error--text text-none"
          flat
          @click="$emit('update:opened', false)"
        >
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ErrorMessageDialog',

  props: {
    opened: {
      type: Boolean,
    },

    message: {
      type: String,
    },
  },

  data() {
    return {};
  },

  methods: {},
};
</script>
